import React, { useState } from 'react';
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { Button, Box, TextField, Typography } from "@mui/material";
import customStyles from "../../../../../assets/styles/customStyles";
import clsx from "clsx";
import { Space, Row, Col } from "antd";
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import DateIcon from "../../../../Shared/components/Icons/Date";
import { checkComponentPermission } from '../../../../../helpers/utilities';


export const FilterProductGroup = (props) => {
    const { customerDetails, handleCloseMobile, roleManagement, customerObject } = props;
    const [mobileFilter, setMobileFilter] = useState({});
    const classes = customStyles();

    const handleMobileSubmit = (e) => {
        e.preventDefault();
        // handleMobileFilter(mobileFilter)
    }

    return (
        <Box component='form'
            autoComplete='off'
            onSubmit={(e) => handleMobileSubmit(e)}
            className={clsx(classes.customForm, classes.removeUnderline)}>
            <div>

                <Typography variant={'h6'} className={clsx(classes.margin15b, classes.textFieldLableColorCustom, classes.fonSize16, 'MuiInputLabel-shrink')}>Customer Specification - Filter</Typography>
                {
                    <AutoCompleteComponent
                        name={"All Customers"}
                        heads={[{ 'key': 'name', 'name': 'Name' }]}
                        details={customerDetails}
                        customClasses={clsx(classes.margin10t)}
                        parentValue={customerObject()}
                        position={"bottom"}
                        onChangeText={(data) => {
                            if (data === '') {
                                setMobileFilter({
                                    ...mobileFilter, customerId: ''
                                });
                            }
                        }}
                        onChange={(data) => {
                            setMobileFilter({
                                ...mobileFilter, customerId: data.id
                            });
                        }}
                    />
                }
                <Row>
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} >
                        <Typography variant={'h6'} className={clsx(classes.margin20t, classes.fonSize16, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink')}>Date - Filter</Typography>
                    </Col>
                    <Col xxl={11} xl={11} lg={11} md={11} sm={11} xs={11} >
                        {
                            <div className={clsx(classes.dateFilterdateAdjustMobile, classes.paddingLeft10P)}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDatePicker
                                        fullWidth
                                        slots={{
                                            openPickerIcon: DateIcon
                                        }}
                                        views={['year', 'month', 'day']}
                                        allowKeyboardControl={false}
                                        slotProps={{ textField: { variant: 'standard', } }}
                                        value={mobileFilter?.startDate}
                                        label="From Date"
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,

                                            },
                                        }}
                                        format="dd/MM/yyyy"
                                        onChange={(newValue, newError) => {
                                            if (newError?.validationError) {
                                                setMobileFilter({
                                                    ...mobileFilter, startDate: null
                                                });
                                            } else {
                                                setMobileFilter({
                                                    ...mobileFilter, startDate: newValue
                                                });
                                            }
                                        }}
                                        renderInput={(params) => <TextField autoComplete='one-time-code' {...params} />}
                                    />
                                </LocalizationProvider>
                            </div>
                        }
                    </Col>
                    <Col xxl={2} xl={2} lg={2} md={2} sm={2} xs={2}></Col>
                    <Col xxl={11} xl={11} lg={11} md={11} sm={11} xs={11}>
                        {
                            roleManagement !== '' && checkComponentPermission('Customer Invoice History', 'Action', 'Date Filter') &&
                            <div className={clsx(classes.dateFilterdateAdjustMobile)}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDatePicker
                                        fullWidth
                                        slots={{
                                            openPickerIcon: DateIcon
                                        }}
                                        views={['year', 'month', 'day']}
                                        allowKeyboardControl={false}
                                        value={mobileFilter?.endDate}
                                        minDate={new Date(mobileFilter?.startDate)}
                                        label="To Date"
                                        slotProps={{ textField: { variant: 'standard', } }}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor
                                            },
                                        }}
                                        format="dd/MM/yyyy"
                                        onChange={(newValue, newError) => {
                                            if (newError?.validationError) {
                                                setMobileFilter({
                                                    ...mobileFilter, endDate: null
                                                });
                                            } else {
                                                setMobileFilter({
                                                    ...mobileFilter, endDate: newValue
                                                });
                                            }
                                        }}
                                        renderInput={(params) => <TextField autoComplete='one-time-code' {...params} />}
                                    />
                                </LocalizationProvider>
                            </div>
                        }
                    </Col>
                </Row>
            </div>

            <div className={clsx(classes.btnParent)}>
                <Space direction="horizontal" align="center"
                    size={[10, 10]}>
                    <Button
                        key="save"
                        color="primary"
                        variant="contained"
                        type="submit"
                        className={classes.modalBtn}
                    >Confirm</Button>
                    <Button
                        key="save"
                        color="primary"
                        variant="contained"
                        onClick={() => handleCloseMobile()}
                        className={clsx(classes.AddMoreBtn)}
                    >Cancel</Button>
                </Space>

            </div>

        </Box >
    )
}                 